// Accent colors per invite-card theme key, used by the app-wide festival banner.
export const FESTIVAL_ACCENTS = {
  royal: { bg: "linear-gradient(120deg,#B8860B 0%,#FFC107 55%,#FFE082 100%)", text: "#2A1A00", glow: "rgba(255,193,7,0.5)", chip: "rgba(0,0,0,0.15)" },
  diwali: { bg: "linear-gradient(120deg,#B71C1C 0%,#E65100 50%,#FF8F00 100%)", text: "#FFFFFF", glow: "rgba(255,140,0,0.55)", chip: "rgba(255,255,255,0.2)" },
  emerald: { bg: "linear-gradient(120deg,#065F46 0%,#059669 55%,#10B981 100%)", text: "#FFFFFF", glow: "rgba(16,185,129,0.5)", chip: "rgba(255,255,255,0.2)" },
  neon: { bg: "linear-gradient(120deg,#6D28D9 0%,#9333EA 55%,#C084FC 100%)", text: "#FFFFFF", glow: "rgba(168,85,247,0.55)", chip: "rgba(255,255,255,0.2)" },
};

export const festivalAccent = (themeKey) => FESTIVAL_ACCENTS[themeKey] || FESTIVAL_ACCENTS.royal;
